
// 应用参数配置
const siteInfo = {
  'app_name':'user',
  'app_version': '3.1.1',  //小程序版本
  'union_id': '-1',  //平台id
  'server_host': 'http://www.thisadmin.cn',  //站点URL
  'site_dist':'users',

  'module_name':'zze_thisadmin',//W7使用
  'uniacid': '2551991', //小程序uniacid 独立版请填写 2551991,W7使用
  'acid': '6',  //W7使用
  'token': '2551991' //将用于接口中的数据安全校验, W7使用
};

export default siteInfo;

